import {
  CoreItemBackend,
  CoreItemType,
  VertexRelation,
  VertexRelationAdd,
  VertexRelationType,
} from '../../../../frontend/src/app/core/core-item/core-item';
import { BasicAction } from '../basic-action';
import { IdRequest, WorkspaceIdRequest } from '../request-response';
import { ResourceName } from '../resource-name';

export const CoreItemGate = {
  resource: ResourceName.coreItem,
  actions: {
    getItem: BasicAction.getItem,
    getItemListByIdList: 'get-item-list-by-id-list',
    getItemListByTypeList: 'get-item-list-by-type-list',
    getItemListByTypeListInTimeRange: 'get-item-list-by-type-list-in-range',
    getItemListByCreatedById: 'get-item-list-by-created-id',

    getItemListAndRelationList: 'get-item-list-and-relation-list',

    update: BasicAction.update,

    addItemList: 'add-item-list',
    batchWriteItemOrRelationList: 'batch-write-metadata-or-relation-list',

    getAllRelationList: 'get-all-relation-list',

    getKeysOnlyByCoreItemTypeList: 'get-keys-only-by-core-item-type-list',

    sendWeeklyReport: 'send-weekly-report',
  },
};

export type CoreItemGateActionTypes = {
  update: {
    request: CoreItemBackend;
    response: CoreItemBackend;
  };
  getItem: {
    request: IdRequest;
    response: CoreItemBackend;
  };
  getItemListByTypeList: {
    request: GetItemListByTypeListRequest;
    response: CoreItemBackend[];
  };
  getItemListByTypeListInTimeRange: {
    request: GetItemListByTypeListInTimeRangeRequest;
    response: CoreItemBackend[];
  };
  getItemListByIdList: {
    request: GetItemListByIdListRequest;
    response: CoreItemBackend[];
  };
  getAllRelationList: {
    request: WorkspaceIdRequest;
    response: any;
  };
  getItemListByCreatedById: {
    request: GetItemListByCreatedByIdRequest;
    response: CoreItemBackend[];
  };

  addItemList: {
    request: AddItemListRequest;
    response: BatchWriteItemOrRelationListResponse;
  };
  batchWriteItemOrRelationList: {
    request: BatchWriteItemOrRelationListRequest;
    response: BatchWriteItemOrRelationListResponse;
  };
  getItemListAndRelationList: {
    request: GetItemListAndRelationListRequest;
    response: GetItemListAndRelationListResponse;
  };
  getKeysOnlyByCoreItemTypeList: {
    request: GetKeysOnlyByCoreItemTypeListRequest;
    response: any;
  };
  sendWeeklyReport: {
    request: any;
    response: any;
  };
};

export interface GetKeysOnlyByCoreItemTypeListRequest {
  workspaceId: string;
  coreItemTypeList: CoreItemType[];
  dateRange?: { startTimeStr: string; endTimeStr: string };
  createdById?: string;
  includeCreatedById?: boolean;
}

export interface GetItemListByCreatedByIdRequest {
  workspaceId: string;
  createdById: string;
  config?: { coreTypeList?: CoreItemType[]; startTimeStr?: string | null; endTimeStr?: string | null };
}

export interface GetItemListByIdListRequest {
  workspaceId: string;
  idList: string[];
  skList?: string[];
}

export interface AddItemListRequest {
  workspaceId: string;
  addItemList: {
    itemBackend: CoreItemBackend;
    coreType: CoreItemType;
    addRelationList?: VertexRelationAdd[];
  }[];
  deleteRelationList?: VertexRelation[];
  deleteMetadataList?: { id: string; sk: string }[];
  updateMetadataList?: CoreItemBackend[];
}

export interface AddItemResponse {
  addedItemList: CoreItemBackend[];
  addedRelationshipList?: VertexRelation[];
  deletedRelationshipList?: VertexRelation[];
  updatedItemList?: CoreItemBackend[];
}

export interface GetItemListAndRelationListRequest {
  workspaceId: string;
  fromIdList: string[];

  config: {
    hasItemList: boolean;
    queryList: {
      relationType: VertexRelationType;
      toType?: CoreItemType;
    }[];
    secondLevelHasItemList?: boolean;
    secondLevelQueryList?: {
      relationType: VertexRelationType;
      toType?: CoreItemType;
    }[];
  };
}

export interface GetItemListAndRelationListResponse {
  queryList: GetItemListAndRelationListQueryRespons;
  secondLevelQueryList?: GetItemListAndRelationListQueryRespons;
}

export interface GetItemListAndRelationListQueryRespons {
  relationList: VertexRelation[];
  itemList?: CoreItemBackend[];
}

export interface GetItemListByTypeListRequest {
  workspaceId: string;
  config?: { coreTypeList?: CoreItemType[]; parentIdList?: string[]; startTimeStr?: string; endTimeStr?: string };
}

export interface GetItemListByTypeListInTimeRangeRequest {
  workspaceId: string;
  coreTypeList: CoreItemType[];
  startTimeStr: string;
  endTimeStr: string;
}

export interface BatchWriteItemOrRelationListRequest {
  workspaceId: string;
  addRelationList?: VertexRelationAdd[];
  deleteRelationList?: VertexRelation[];
  addMetadataList?: { type: CoreItemType; metadata: Partial<CoreItemBackend> }[];
  deleteMetadataList?: { id: string; sk: string }[];
  updateMetadataList?: CoreItemBackend[];
}

export interface BatchWriteItemOrRelationListResponse {
  addedMetadataList: CoreItemBackend[];
  addedRelationList: VertexRelation[];
  updatedMetadataList?: CoreItemBackend[];
}
